import React, { useContext } from 'react';
import WDSButton, { ButtonProps } from '../Button';
import { SplitActionContext } from './SplitActionContext';
import { st, classes } from './SplitAction.st.css';

export const SplitActionButton: React.FC<ButtonProps> = ({
  children,
  className,
  ...rest
}) => {
  const shared = useContext(SplitActionContext);
  return (
    <WDSButton
      {...shared}
      {...rest}
      data-split-action-button
      className={st(classes.splitActionButton, className)}
    >
      {children}
    </WDSButton>
  );
};
SplitActionButton.displayName = 'SplitActionButton';
